var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactPhone = function SvgContactPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.6,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5091",
    transform: "translate(-905 -852)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 356",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(905 852)",
    fill: "#E81E61",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.999 866.821v2.333a1.557 1.557 0 0 1-1.7 1.556 15.443 15.443 0 0 1-6.726-2.388 15.182 15.182 0 0 1-4.676-4.667 15.373 15.373 0 0 1-2.391-6.734 1.557 1.557 0 0 1 1.551-1.7h2.338a1.558 1.558 0 0 1 1.559 1.338 9.971 9.971 0 0 0 .546 2.186 1.553 1.553 0 0 1-.351 1.641l-.99.988a12.457 12.457 0 0 0 4.676 4.667l.99-.988a1.561 1.561 0 0 1 1.644-.35 10.023 10.023 0 0 0 2.19.544 1.556 1.556 0 0 1 1.34 1.574Z",
    fill: "none",
    stroke: "#E81E61",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
};
export default SvgContactPhone;